import React from 'react';
import Loadable from 'react-loadable';
import { hydrate, render } from "react-dom";
import {Route, Switch, BrowserRouter} from 'react-router-dom';

import {createBrowserHistory} from 'history';
import { Provider } from 'react-redux';

import configureStore from "./store/configureStore";

import './index.css';
import App from './containers/App';
import registerServiceWorker from './registerServiceWorker';


// Confugre store
// Instantiate store
// Override state from server here if needed
// Overrides initial state to reducers via argument below
// Server rendered app, you might want to pass intialstate as the optional parameter
// inconfigure store
// Server hydrate initial state or Localstate initialstate
const store = configureStore();

// To fetch the app data when the app loads
// Dispatch actions against teh store
// Without server rendering
// store.dispatch(projectActions.loadProjects());
// store.dispatch(authorActions.loadAuthors());

// ReactDOM.hydrate(
//     <App />,
//     document.getElementById('root')
// );

const rootElement = document.getElementById("root");


Loadable.preloadReady().then(() => {
    if (rootElement.hasChildNodes()) {
        hydrate(
            <Provider store={store}>
                <BrowserRouter>
                    <App>
                        <Switch>
                        </Switch>
                    </App>
                </BrowserRouter>
            </Provider>
            , rootElement);
    } else {
        render(
            <Provider store={store}>
                <BrowserRouter>
                    <App>
                        <Switch>
                        </Switch>
                    </App>
                </BrowserRouter>
            </Provider>
            , rootElement);
    }
});

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js